import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormConfiguracao.vue?vue&type=template&id=516aa68b"
import script from "./PlanejamentoAcaoVerbaVariavelFormConfiguracao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports